import { FaSearch } from "react-icons/fa";

export default function SearchInput({
  placeholder = "",
  value,
  onChange,
  type = "text",
  className = "",
  wrapperClassName = "",
  ...rest
}) {
  return (
    <div className={`relative ${wrapperClassName}`}>
      <div className="absolute inset-y-0 left-0 pl-2.5 sm:pl-3 flex items-center pointer-events-none">
        <FaSearch className="text-gray-400 w-3.5 h-3.5" />
      </div>
      <input
        type={type}
        className={`block w-full pl-8 sm:pl-10 pr-2 sm:pr-3 py-2 sm:py-2.5 border text-xs sm:text-sm border-gray-200 rounded-lg sm:rounded-xl leading-5 bg-white placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition-all duration-200 disabled:cursor-not-allowed disabled:bg-gray-50 disabled:text-gray-400 disabled:placeholder-gray-300 ${className}`}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        {...rest}
      />
    </div>
  );
}
